/* JellyChic header, menu, search, country and footer (jc-nav) · sections/jc-nav-header.liquid, sections/jc-footer.liquid
   · The bar hides going down and comes back going up (like Dawn's "on scroll up"), never while a menu is open.
     --header-height is kept up to date for Dawn's scripts.
   · Desktop colour panel: hover the shop link (90ms intent), or its chevron button (keyboard: focus moves in,
     Esc returns). Hover a colour: the panel wears it, the button names him, he hops.
   · Phone menu, search, country: <dialog>s (showModal: focus stays inside, Esc closes, aria-expanded on every
     opener, focus goes back to the opener). They fade; the body does not scroll behind them.
   · Colours: on a page with the buy box (the fold's radio inputs jc-slot-<id>-1), a colour tapped in the menu, the
     panel, the search or the footer shelf is picked there (jc.js repaints the page) and we scroll to the buy button;
     elsewhere the link goes to /products/<jelkin>?colour=<slug>.
   · "Her colour": the fold's colour (jc.js sets --sw on <html>; we watch it), else the last one she chose
     (localStorage jc-sel, written by jc.js), else the product's first. The menu starts on it, the buttons name it,
     the footer saves it, the peeking bag wears it.
   · Search: local and instant for colours (names + everyday words) and quick answers; pages, articles and
     collections from /search/suggest.json. Arrow keys move through the results; Enter opens the only colour found.
   · Country: the list is built from JSON on first open (no 200-button DOM on every page); each row is a submit
     button of the localization form (name=country_code), so choosing = one tap.
   · Only the bags move: hops (squash and stretch), squish, the wave, the peek. Reduced motion: none of it.
   · Loaded by the header and the footer: runs once. Re-inits on shopify:section:load. */
(function () {
  'use strict';
  // The few words this script writes itself, in the page's language (window.jcT, from the theme's locale files)
  function jcTx(k, d) { var t = window.jcT; return t && typeof t[k] === 'string' ? t[k] : d; }
  if (window.jcNav) return;
  var api = window.jcNav = {};

  var rmq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var wide = window.matchMedia('(min-width: 1024px)');
  var hoverable = window.matchMedia('(hover: hover)');
  function still() { return rmq.matches; }
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function norm(s) { s = String(s || '').toLowerCase(); return s.normalize ? s.normalize('NFKD').replace(/[̀-ͯ]/g, '') : s; }
  function tokens(s) { return norm(s).split(/[^a-z0-9\u3400-\u9fff]+/).filter(Boolean); }
  function store(k) { try { return JSON.parse(window.localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function track(name, detail) {
    window.dataLayer = window.dataLayer || [];
    var p = { event: 'jc_' + name };
    if (detail) Object.keys(detail).forEach(function (k) { p[k] = detail[k]; });
    window.jcPush(p);
  }
  var ARROW = '<svg class="jc-icon" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var TICK = '<svg class="jc-icon jc-nav-cl__tick" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.2 4.2L19 7"/></svg>';

  /* ---------- Data (from the header section; the footer can live without it) ---------- */
  var D = null;
  function data() {
    if (D) return D;
    var el = $('[data-jc-nav-data]');
    if (!el) return null;
    try { D = JSON.parse(el.textContent); } catch (e) { D = null; return null; }
    D.colours = D.colours || [];
    return D;
  }
  function colour(slug) {
    if (!slug) return null;
    var d = data();
    if (d) for (var i = 0; i < d.colours.length; i++) if (d.colours[i].s === slug) return d.colours[i];
    var a = $('[data-jc-nav-colour="' + slug + '"][data-hex]');
    if (!a) return null;
    return { s: slug, n: a.getAttribute('data-name'), h: a.getAttribute('data-hex'), u: a.getAttribute('href') };
  }
  function allColours() {
    var d = data();
    if (d && d.colours.length) return d.colours;
    var seen = {}, out = [];
    $$('[data-jc-nav-colour][data-hex]').forEach(function (a) { var s = a.getAttribute('data-jc-nav-colour'); if (!seen[s]) { seen[s] = 1; out.push(colour(s)); } });
    return out;
  }
  function byHex(hex) { hex = String(hex || '').trim().toLowerCase(); var l = allColours(); for (var i = 0; i < l.length; i++) if (String(l[i].h).toLowerCase() === hex) return l[i]; return null; }
  function byName(name) { name = norm(name).trim(); var l = allColours(); for (var i = 0; i < l.length; i++) if (norm(l[i].n) === name) return l[i]; return null; }

  /* A cut-out <img> switched to another colour (same widths as snippets/jc-nav-bag) */
  function swapImg(img, slug) {
    if (!img || img.getAttribute('data-slug') === slug) return;
    var c = colour(slug), base = c && c.i;
    if (!base) { var t = $('[data-jc-nav-colour="' + slug + '"] img'); if (!t) return; img.src = t.getAttribute('src'); if (t.getAttribute('srcset')) img.srcset = t.getAttribute('srcset'); img.setAttribute('data-slug', slug); return; }
    img.srcset = [160, 240, 360, 480].map(function (w) { return base + '&width=' + w + ' ' + w + 'w'; }).join(', ');
    img.src = base + '&width=240';
    img.setAttribute('data-slug', slug);
  }

  /* ---------- Bag motion (the only thing that moves) ---------- */
  function play(el, frames, opts) {
    if (!el || still() || typeof el.animate !== 'function') return null;
    if (el._jcAnim) { try { el._jcAnim.cancel(); } catch (e) { /* gone */ } }
    el._jcAnim = el.animate(frames, opts);
    return el._jcAnim;
  }
  function hop(el, h, delay) {
    h = h || 12;
    return play(el, [
      { transform: 'translate3d(0,0,0) scale(1,1)' },
      { transform: 'translate3d(0,0,0) scale(1.07,0.93)', offset: 0.14 },
      { transform: 'translate3d(0,' + (-h) + 'px,0) scale(0.95,1.06)', offset: 0.42 },
      { transform: 'translate3d(0,0,0) scale(1.08,0.92)', offset: 0.68 },
      { transform: 'translate3d(0,0,0) scale(0.98,1.02)', offset: 0.84 },
      { transform: 'translate3d(0,0,0) scale(1,1)' }
    ], { duration: 580, delay: delay || 0, easing: 'ease-out' });
  }
  function squish(el) {
    return play(el, [
      { transform: 'scale(1,1)' },
      { transform: 'scale(1.16,0.84)', offset: 0.18 },
      { transform: 'scale(0.93,1.08)', offset: 0.46 },
      { transform: 'scale(1.04,0.97)', offset: 0.7 },
      { transform: 'scale(1,1)' }
    ], { duration: 640, easing: 'ease-out' });
  }
  function wobble(el, delay) {
    return play(el, [
      { transform: 'rotate(0deg)' },
      { transform: 'rotate(-7deg)', offset: 0.2 },
      { transform: 'rotate(6deg)', offset: 0.45 },
      { transform: 'rotate(-3deg)', offset: 0.7 },
      { transform: 'rotate(1deg)', offset: 0.86 },
      { transform: 'rotate(0deg)' }
    ], { duration: 1300, delay: delay || 0, easing: 'ease-in-out' });
  }
  function wave(els, gap, h) { els.forEach(function (el, i) { hop(el, h || 12, i * (gap || 50)); }); }
  function inView(el, root) {
    var r = el.getBoundingClientRect(), b = root ? root.getBoundingClientRect() : { left: 0, right: window.innerWidth, top: 0, bottom: window.innerHeight };
    return r.right > b.left && r.left < b.right && r.bottom > b.top && r.top < b.bottom;
  }

  /* ---------- Her colour ---------- */
  var cur = null;
  var savePicked = false;
  function foldInput(slug) {
    var ins = $$('input[type="radio"][name^="jc-slot-"][name$="-1"]');
    for (var i = 0; i < ins.length; i++) if (ins[i].value === slug) return ins[i];
    return null;
  }
  function hasFold() { return !!$('input[type="radio"][name^="jc-slot-"][name$="-1"]'); }
  function setCta(a, c) {
    if (!a || !c) return;
    var n = $('[data-jc-nav-cta-name]', a);
    if (n && n.textContent !== c.n) n.textContent = c.n;
    if (c.u) a.setAttribute('href', c.u);
    a.setAttribute('data-slug', c.s);
  }
  function setPeek(p, c) {
    if (!p || !c) return;
    p.style.setProperty('--c', c.h);
    swapImg($('img', p), c.s);
  }
  function setCurrent(slug) {
    var c = colour(slug);
    if (!c) return;
    cur = slug;
    $$('[data-jc-nav-cta]').forEach(function (a) { if (!a.closest('dialog[open]') && !a.closest('.jc-nav-mega.is-open')) setCta(a, c); });
    $$('[data-jc-nav-peek]').forEach(function (p) { if (!p.closest('dialog[open]')) setPeek(p, c); });
    $$('[data-jc-nf]').forEach(function (f) { if (f._jcSave && !savePicked) f._jcSave(slug, true); });
  }
  function watchPageColour() {
    var last = '';
    function read() {
      var sw = document.documentElement.style.getPropertyValue('--sw').trim().toLowerCase();
      if (!sw || sw === last) return;
      last = sw;
      var c = byHex(sw);
      if (c) setCurrent(c.s);
    }
    new MutationObserver(read).observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
    read();
  }

  /* Pick a colour on this page's buy box instead of loading a new page. Returns true when it did. */
  function pickOnPage(slug, el) {
    var input = foldInput(slug);
    if (!input || input.disabled) return false;
    var dlg = el && el.closest('dialog');
    if (dlg) closeDialog(dlg, true, true);
    closeMega(false);
    if (!input.checked) input.click();
    setCurrent(slug);
    var fromFoot = el && el.closest('.jc-nf');
    var target = fromFoot ? ($('[data-jc-final-cta]') || null) : null;
    var fold = input.closest('product-component') || input.closest('.shopify-section');
    var hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
    var y;
    if (target) {
      var r = target.getBoundingClientRect();
      y = window.scrollY + r.top - Math.max(hh, (window.innerHeight - r.height) / 2);
    } else if (fold) {
      y = window.scrollY + fold.getBoundingClientRect().top - hh;
    }
    if (y != null) {
      var far = Math.abs(y - window.scrollY) > window.innerHeight * 3;
      window.scrollTo({ top: Math.max(0, y), behavior: still() || far ? 'auto' : 'smooth' });
    }
    track('nav_pick', { jc_colour: slug, from: fromFoot ? 'footer' : (dlg ? dlg.id : 'panel') });
    return true;
  }

  /* ---------- Dialogs ---------- */
  var openers = {}, closers = {};
  function anyOpen() { return !!$('dialog[data-jc-nav-dialog][open]'); }
  function expanded(id, on) { $$('[aria-controls="' + id + '"][aria-expanded]').forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); }); }
  function openDialog(dlg, trigger, viaPointer) {
    if (!dlg || typeof dlg.showModal !== 'function') return false;
    wireDialog(dlg);
    if (dlg.open) return true;
    closeMega(false);
    $$('dialog[data-jc-nav-dialog][open]').forEach(function (d) { closeDialog(d, true, true); });
    dlg._jcTrigger = trigger || document.activeElement;
    try { dlg.showModal(); } catch (e) { return false; }
    document.documentElement.classList.add('jc-nav-lock');
    expanded(dlg.id, true);
    if (still()) dlg.classList.add('is-open');
    else requestAnimationFrame(function () { requestAnimationFrame(function () { if (dlg.open) dlg.classList.add('is-open'); }); });
    // Opened with a tap or a click: no focus ring on the close button (keyboard users still land on it)
    if (viaPointer && dlg.id !== 'JcNavSearch') { var box = dlg.firstElementChild; if (box) { box.setAttribute('tabindex', '-1'); try { box.focus({ preventScroll: true }); } catch (e) { box.focus(); } } }
    if (openers[dlg.id]) openers[dlg.id](dlg);
    return true;
  }
  function closeDialog(dlg, quick, noFocus) {
    if (!dlg || !dlg.open) return;
    dlg._jcNoFocus = !!noFocus;
    dlg.classList.remove('is-open');
    clearTimeout(dlg._jcT);
    if (quick || still()) dlg.close();
    else dlg._jcT = setTimeout(function () { if (dlg.open) dlg.close(); }, 200);
  }
  function wireDialog(dlg) {
    if (dlg._jcWired) return;
    dlg._jcWired = true;
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); closeDialog(dlg); });
    dlg.addEventListener('close', function () {
      clearTimeout(dlg._jcT);
      dlg.classList.remove('is-open');
      expanded(dlg.id, false);
      if (!anyOpen()) document.documentElement.classList.remove('jc-nav-lock');
      var t = dlg._jcTrigger;
      dlg._jcTrigger = null;
      if (!dlg._jcNoFocus && t && t.isConnected && typeof t.focus === 'function') { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } }
      dlg._jcNoFocus = false;
      if (closers[dlg.id]) closers[dlg.id](dlg);
    });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) closeDialog(dlg); });
  }
  api.open = function (id, trigger) { return openDialog(document.getElementById(id), trigger); };
  api.close = function (id) { closeDialog(document.getElementById(id)); };

  /* ---------- The bag icon: count mirror (menu), a hop when a bag lands ---------- */
  var lastCount = null;
  function cartCount() {
    var b = document.getElementById('cart-icon-bubble');
    var n = b && b.querySelector('.cart-count-bubble span[aria-hidden]');
    return n ? n.textContent.trim() : '';
  }
  function syncCount() {
    var txt = cartCount(), num = parseInt(txt, 10) || 0;
    $$('[data-jc-nav-count]').forEach(function (el) { el.textContent = txt; el.hidden = !txt; });
    if (lastCount !== null && num > lastCount) {
      var b = document.getElementById('cart-icon-bubble');
      setTimeout(function () { hop(b, 7); }, 620); // jc.js's flying bag lands at ~650ms
    }
    lastCount = num;
  }
  function initCartIcon() {
    var b = document.getElementById('cart-icon-bubble');
    if (!b || b._jcObs) return;
    b._jcObs = true;
    syncCount();
    b.addEventListener('mouseenter', function () { if (hoverable.matches) hop(b, 5); });
    new MutationObserver(syncCount).observe(b, { childList: true, subtree: true, characterData: true });
  }
  function openCart(btn) {
    var d = btn.closest('dialog');
    if (d) closeDialog(d, true, true);
    var drawer = document.querySelector('cart-drawer');
    var bubble = document.getElementById('cart-icon-bubble');
    if (drawer && typeof drawer.open === 'function') drawer.open(bubble || btn);
    else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  /* ---------- Sticky bar: hide going down, back going up ---------- */
  var megaApi = { isOpen: false, close: function () {} };
  function closeMega(focus) { if (megaApi.isOpen) megaApi.close(focus); }
  function initSticky(root) {
    var sec = root.closest('.shopify-section') || root.parentElement;
    if (!sec || sec._jcSticky) return;
    sec._jcSticky = true;
    var mode = root.getAttribute('data-sticky') || 'on-scroll-up';
    var html = document.documentElement;
    if (mode === 'none') sec.classList.add('is-static');
    function setH() { var h = sec.offsetHeight; html.style.setProperty('--header-height', h + 'px'); html.style.setProperty('--jc-nav-h', h + 'px'); }
    setH();
    if ('ResizeObserver' in window) new ResizeObserver(setH).observe(sec);
    if (mode !== 'on-scroll-up') return;
    var lastY = Math.max(0, window.scrollY || 0), raf = 0, hidden = false;
    function set(h) {
      if (h === hidden) return;
      hidden = h;
      sec.classList.toggle('is-hidden', h);
      if (h) { closeMega(false); closeDrops(root); }
    }
    window.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var y = Math.max(0, window.scrollY || 0), dy = y - lastY;
        if (y < 140) set(false);
        else if (dy > 6 && !megaApi.isOpen && !anyOpen()) set(true);
        else if (dy < -6) set(false);
        if (Math.abs(dy) > 6 || y < 140) lastY = y;
      });
    }, { passive: true });
    sec.addEventListener('focusin', function () { set(false); });
  }

  /* ---------- Desktop: sub-menus of nested admin links ---------- */
  function closeDrops(root, except) {
    $$('[data-jc-nav-drop-toggle][aria-expanded="true"]', root || document).forEach(function (b) {
      if (b === except) return;
      b.setAttribute('aria-expanded', 'false');
      var ul = document.getElementById(b.getAttribute('aria-controls'));
      if (ul) ul.hidden = true;
    });
  }
  function initDrops(root) {
    $$('[data-jc-nav-drop-toggle]', root).forEach(function (b) {
      if (b._jc) return;
      b._jc = true;
      b.addEventListener('click', function () {
        var ul = document.getElementById(b.getAttribute('aria-controls'));
        var on = b.getAttribute('aria-expanded') !== 'true';
        closeDrops(root, b);
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (ul) ul.hidden = !on;
      });
      /* With a mouse, the dropdown also opens on hover (like the colour panel), and closes a beat after she leaves */
      var item = b.closest('[data-jc-nav-drop]'), tIn = 0, tOut = 0;
      if (!item) return;
      function set(on) {
        var ul = document.getElementById(b.getAttribute('aria-controls'));
        if (on) closeDrops(root, b);
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (ul) ul.hidden = !on;
      }
      item.addEventListener('mouseenter', function () { if (!hoverable.matches) return; clearTimeout(tOut); tIn = setTimeout(function () { set(true); }, 90); });
      item.addEventListener('mouseleave', function () { if (!hoverable.matches) return; clearTimeout(tIn); tOut = setTimeout(function () { set(false); }, 220); });
    });
  }

  /* ---------- Desktop colour panel ---------- */
  function initMega(root) {
    var item = $('[data-jc-nav-mega-item]', root), panel = $('[data-jc-nav-mega]', root), toggle = $('[data-jc-nav-mega-toggle]', root), scrim = $('[data-jc-nav-scrim]', root);
    if (!item || !panel || !toggle || panel._jc) return;
    panel._jc = true;
    var tIn = 0, tOut = 0, tHide = 0, shown = null;
    var cta = $('[data-jc-nav-cta]', panel);
    function preview(a) {
      var s = a.getAttribute('data-jc-nav-colour');
      if (s === shown) return;
      shown = s;
      var c = colour(s);
      if (!c) return;
      panel.style.setProperty('--nav-sw', c.h);
      setCta(cta, c);
      hop($('[data-jc-nav-hop]', a), 10);
    }
    function open(focusIn) {
      clearTimeout(tOut); clearTimeout(tHide);
      if (!wide.matches) return;
      if (!megaApi.isOpen) {
        panel.hidden = false;
        if (scrim) scrim.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        item.classList.add('is-open');
        megaApi.isOpen = true;
        var c = colour(cur);
        if (c) { panel.style.setProperty('--nav-sw', c.h); setCta(cta, c); shown = c.s; }
        requestAnimationFrame(function () { panel.classList.add('is-open'); if (scrim) scrim.classList.add('is-open'); });
        wave($$('[data-jc-nav-hop]', panel), 32, 10);
        track('nav_panel');
      }
      if (focusIn) { var f = $('a[href], button', panel); if (f) f.focus(); }
    }
    function close(focusToggle) {
      clearTimeout(tIn); clearTimeout(tOut);
      if (!megaApi.isOpen) return;
      megaApi.isOpen = false;
      panel.classList.remove('is-open');
      if (scrim) scrim.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      item.classList.remove('is-open');
      tHide = setTimeout(function () { if (!megaApi.isOpen) { panel.hidden = true; if (scrim) scrim.hidden = true; } }, still() ? 0 : 200);
      if (focusToggle) toggle.focus();
    }
    megaApi.close = close;
    item.addEventListener('mouseenter', function () { if (!hoverable.matches) return; clearTimeout(tOut); tIn = setTimeout(function () { open(false); }, 90); });
    item.addEventListener('mouseleave', function () { clearTimeout(tIn); tOut = setTimeout(function () { close(false); }, 220); });
    panel.addEventListener('mouseenter', function () { clearTimeout(tOut); });
    panel.addEventListener('mouseleave', function () { tOut = setTimeout(function () { close(false); }, 220); });
    toggle.addEventListener('click', function () { if (megaApi.isOpen) close(false); else open(true); });
    if (scrim) scrim.addEventListener('click', function () { close(false); });
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape' && megaApi.isOpen) { e.preventDefault(); close(true); } });
    root.addEventListener('focusout', function (e) {
      var to = e.relatedTarget;
      if (megaApi.isOpen && to && !panel.contains(to) && !item.contains(to)) close(false);
    });
    $$('[data-jc-nav-colour]', panel).forEach(function (a) {
      a.addEventListener('mouseenter', function () { preview(a); });
      a.addEventListener('focus', function () { preview(a); });
    });
    wide.addEventListener && wide.addEventListener('change', function () { if (!wide.matches) close(false); });
  }

  /* ---------- Phone menu: the rail wears the colour in the middle ---------- */
  function initMenu(dlg) {
    if (dlg._jcMenu) return;
    dlg._jcMenu = true;
    var rail = $('[data-jc-nav-rail]', dlg), tint = $('[data-jc-nav-tint]', dlg), cta = $('[data-jc-nav-cta]', dlg), scroller = $('[data-jc-nav-scroll]', dlg);
    var peek = $('[data-jc-nav-peek]', dlg);
    var lis = rail ? $$('.jc-nav-fam__li', rail) : [];
    var centred = null, raf = 0;
    function pickCentred(li) {
      var a = $('[data-jc-nav-colour]', li), c = a && colour(a.getAttribute('data-jc-nav-colour'));
      if (!c) return;
      if (tint) tint.style.setProperty('--nav-sw', c.h);
      setCta(cta, c);
      if (peek) setPeek(peek, c);
    }
    function measure() {
      raf = 0;
      if (!rail || !dlg.open || !lis.length) return;
      var r = rail.getBoundingClientRect(), mid = r.left + r.width / 2, ds = [], best = null, bd = Infinity;
      var w = lis[0].getBoundingClientRect().width || 132;
      lis.forEach(function (li) { var b = li.getBoundingClientRect(), d = Math.abs(b.left + b.width / 2 - mid); ds.push(d); if (d < bd) { bd = d; best = li; } });
      if (!still()) lis.forEach(function (li, i) { li.style.setProperty('--k', (1 - Math.min(1, ds[i] / (w * 1.25)) * 0.18).toFixed(3)); });
      if (best && best !== centred) { centred = best; pickCentred(best); }
    }
    if (rail) rail.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(measure); }, { passive: true });
    window.addEventListener('resize', function () { if (dlg.open) { if (wide.matches) closeDialog(dlg, true); else if (!raf) raf = requestAnimationFrame(measure); } });
    var peekIO = null;
    openers[dlg.id] = function () {
      if (scroller) scroller.scrollTop = 0;
      centred = null;
      if (rail && lis.length) {
        // Her colour in the middle of the family, the others around her (the list turns like a carousel)
        var at = Math.max(0, lis.findIndex(function (l) { return l.getAttribute('data-jc-nav-tile') === cur; }));
        var shift = (at - Math.floor(lis.length / 2) + lis.length) % lis.length;
        if (shift) { lis = lis.slice(shift).concat(lis.slice(0, shift)); lis.forEach(function (l) { rail.appendChild(l); }); }
        var li = lis[Math.floor(lis.length / 2)];
        var r = rail.getBoundingClientRect(), b = li.getBoundingClientRect();
        rail.scrollLeft += (b.left + b.width / 2) - (r.left + r.width / 2);
        measure();
        var hops = lis.filter(function (l) { return inView(l, rail); }).map(function (l) { return $('[data-jc-nav-hop]', l); });
        setTimeout(function () { wave(hops, 70, 14); }, 120);
      }
      if (peek) {
        peek.classList.remove('is-in');
        if ('IntersectionObserver' in window && scroller) {
          if (peekIO) peekIO.disconnect();
          peekIO = new IntersectionObserver(function (es) {
            es.forEach(function (e) {
              if (!e.isIntersecting) return;
              peekIO.disconnect();
              peek.classList.add('is-in');
              wobble($('[data-jc-nav-peek-bag]', peek), 650);
            });
          }, { root: scroller, threshold: 0.5 });
          peekIO.observe(peek);
        } else peek.classList.add('is-in');
      }
      track('nav_menu');
    };
    closers[dlg.id] = function () { if (peekIO) peekIO.disconnect(); };
  }

  /* ---------- Search ---------- */
  function initSearch(dlg) {
    if (dlg._jcSearch) return;
    var d = data();
    var input = $('[data-jc-nav-q]', dlg), out = $('[data-jc-nav-results]', dlg), status = $('[data-jc-nav-status]', dlg), form = $('[data-jc-nav-search-form]', dlg);
    if (!d || !input || !out) return;
    dlg._jcSearch = true;
    var S = d.strings || {};
    var words = {};
    String(d.words || '').split(/\n/).forEach(function (l) { var i = l.indexOf(':'); if (i > 0) words[l.slice(0, i).trim()] = l.slice(i + 1); });
    var cols = d.colours.map(function (c) { return { c: c, keys: tokens(c.n + ' ' + c.s.replace(/-/g, ' ') + ' ' + (words[c.s] || '')) }; });
    var help = (d.help || []).map(function (h) { return { h: h, keys: tokens(h.t + ' ' + (h.k || '')) }; });
    var GENERIC = tokens('jelkin jelkins bag bags birkin colour colours color colors all family jellychic handbag the a an in 包 包包 毛毛包 手袋 毛毛手袋 顏色 色');
    var remote = [], ctrl = null, timer = 0, lastQ = null, lastColours = [], lastHelp = [];

    function starts(t, keys) { var cjk = /[\u3400-\u9fff]/.test(t); for (var i = 0; i < keys.length; i++) if (cjk ? keys[i].indexOf(t) > -1 || (keys[i].length > 1 && t.indexOf(keys[i]) > -1) : keys[i].indexOf(t) === 0) return true; return false; }
    function tile(c) {
      var ss = [160, 240, 360].map(function (w) { return c.i + '&width=' + w + ' ' + w + 'w'; }).join(', ');
      return '<li><a class="jc-nav-fam" href="' + esc(c.u) + '" data-jc-nav-colour="' + esc(c.s) + '" data-name="' + esc(c.n) + '" data-hex="' + esc(c.h) + '" style="--c: ' + esc(c.h) + ';" data-track="search_colour">' +
        '<span class="jc-nav-fam__disc" aria-hidden="true"><span class="jc-nav-fam__bag" data-jc-nav-hop><img class="jc-nav-fam__img" src="' + esc(c.i + '&width=240') + '" srcset="' + esc(ss) + '" sizes="(min-width: 1024px) 128px, 30vw" width="240" height="240" alt="" loading="lazy" decoding="async" draggable="false"></span></span>' +
        '<span class="jc-nav-fam__name">' + esc(c.n) + '</span>' +
        (c.b ? '<span class="jc-nav-fam__best">' + esc(S.best || 'Bestseller') + '</span>' : '') +
        (c.a ? '' : '<span class="jc-nav-fam__out">' + esc(S.out || 'Sold out') + '</span>') + '</a></li>';
    }
    function grid(list, strip) { return '<ul class="jc-nav-fams ' + (strip ? 'jc-nav-fams--strip' : 'jc-nav-fams--search') + '" role="list">' + list.map(tile).join('') + '</ul>'; }
    // Owner's pairings (Theme settings → JellyChic → complements: "biscuit: rose-sakura, noir")
    var pairs = {};
    String(d.pairs || '').split(/\n/).forEach(function (l) { var i = l.indexOf(':'); if (i > 0) pairs[l.slice(0, i).trim()] = l.slice(i + 1).split(',').map(function (x) { return x.trim(); }).filter(Boolean); });
    function pairsOf(slug) { return (pairs[slug] || []).map(function (x) { return colour(x); }).filter(function (c) { return c && c.s !== slug; }); }
    function links(list) {
      return '<ul class="jc-nav-sr__list" role="list">' + list.map(function (h) {
        return '<li><a class="jc-nav-sr__a" href="' + esc(h.u) + '" data-track="search_answer"><span>' + esc(h.t) + '</span>' + ARROW + '</a></li>';
      }).join('') + '</ul>';
    }
    function sect(h, body, cls) { return '<section class="jc-nav-sr' + (cls ? ' ' + cls : '') + '"><h3 class="jc-nav-sr__h">' + esc(h) + '</h3>' + body + '</section>'; }
    function path(u) { return String(u || '').split(/[?#]/)[0]; }
    function render(q) {
      var qt = tokens(q), sig = qt.filter(function (t) { return GENERIC.indexOf(t) < 0; });
      var html = '', cs, hs;
      if (!qt.length) {
        cs = d.colours;
        hs = help.filter(function (x) { return x.h.q; }).map(function (x) { return x.h; }).slice(0, 8);
        html = sect(S.colours || 'Colours', grid(cs, true)) + (hs.length ? sect(S.help || 'Quick answers', links(hs)) : '');
      } else {
        cs = sig.length ? cols.filter(function (x) { return sig.every(function (t) { return starts(t, x.keys); }); }).map(function (x) { return x.c; }) : d.colours;
        var scored = help.map(function (x) { var n = 0; qt.forEach(function (t) { if (t.length > 1 && starts(t, x.keys)) n++; }); return { h: x.h, n: n }; })
          .filter(function (o) { return o.n > 0; }).sort(function (a, b) { return b.n - a.n; }).map(function (o) { return o.h; });
        var seen = {};
        hs = [];
        scored.concat(remote).forEach(function (h) { var k = path(h.u); if (!seen[k]) { seen[k] = 1; hs.push(h); } });
        hs = hs.slice(0, 8);
        if (cs.length) {
          // The colours she asked for; one colour → the ones the owner pairs him with
          html += sect(S.colours || 'Colours', grid(cs));
          var pr = cs.length === 1 ? pairsOf(cs[0].s) : [];
          if (pr.length && S.pairs) html += sect(String(S.pairs).replace('[colour]', cs[0].n), grid(pr), 'jc-nav-sr--side');
          if (hs.length) html += sect(S.help || 'Quick answers', links(hs));
        } else if (hs.length) {
          // A question: answers first, the family underneath
          html += sect(S.help || 'Quick answers', links(hs)) + sect(S.family || S.colours || 'Colours', grid(d.colours, true), 'jc-nav-sr--side');
        } else {
          html += '<p class="jc-nav-sr__note">' + esc(S.empty || '') + '</p>' + sect(S.colours || 'Colours', grid(d.colours));
        }
        var allLabel = String(S.all || 'Search everything for “[q]”').replace('[q]', q);
        html += '<div class="jc-nav-sr jc-nav-sr--all"><a class="jc-nav-sr__all" href="' + esc((d.searchUrl || '/search') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last') + '">' + esc(allLabel) + ARROW + '</a></div>';
      }
      var changed = cs.map(function (c) { return c.s; }).join() !== lastColours.map(function (c) { return c.s; }).join();
      out.innerHTML = html;
      lastColours = qt.length ? cs : [];
      lastHelp = hs;
      if (status) status.textContent = qt.length ? String(S.found || '[n] results').replace('[n]', cs.length + hs.length) : '';
      if (changed) wave($$('[data-jc-nav-hop]', out).slice(0, 12), 35, 10);
    }
    function fetchRemote(q) {
      if (!d.suggestUrl || !window.fetch) return;
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = d.suggestUrl + '.json?q=' + encodeURIComponent(q) + '&resources%5Btype%5D=page,article,collection&resources%5Blimit%5D=4';
      fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || input.value.trim() !== q) return;
          var R = (j.resources && j.resources.results) || {};
          remote = [].concat(R.pages || [], R.articles || [], R.collections || []).map(function (x) { return { t: x.title, u: x.url }; });
          render(q);
        }).catch(function () { /* offline or aborted: the local results stay */ });
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (q === lastQ) return;
      lastQ = q;
      remote = [];
      render(q);
      clearTimeout(timer);
      if (q.length > 1) timer = setTimeout(function () { fetchRemote(q); }, 180);
    });
    // Esc closes the search in one press (a search field would otherwise only clear itself first)
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); closeDialog(dlg); } });
    dlg.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var ls = $$('a[href]', out);
      if (!ls.length) return;
      var i = ls.indexOf(document.activeElement);
      e.preventDefault();
      if (e.key === 'ArrowDown') (ls[i + 1] || ls[0]).focus();
      else if (i <= 0) input.focus();
      else ls[i - 1].focus();
    });
    if (form) form.addEventListener('submit', function (e) {
      var q = input.value.trim();
      if (!q) { e.preventDefault(); return; }
      var go = null;
      if (lastColours.length === 1) go = $('[data-jc-nav-colour]', out);
      else if (!lastColours.length && lastHelp.length) go = $('.jc-nav-sr__a', out);
      if (go) { e.preventDefault(); go.click(); }
    });
    openers[dlg.id] = function () {
      input.value = '';
      lastQ = '';
      remote = [];
      render('');
      try { input.focus({ preventScroll: true }); } catch (x) { input.focus(); }
      track('nav_search');
    };
  }

  /* ---------- Country and currency ---------- */
  var ALIAS = { uk: 'GB', britain: 'GB', england: 'GB', scotland: 'GB', wales: 'GB', usa: 'US', america: 'US', us: 'US', uae: 'AE', emirates: 'AE', holland: 'NL', korea: 'KR' };
  function initCountry(dlg) {
    if (dlg._jcCountry) return;
    var raw = $('[data-jc-nav-countries]', dlg), list = $('[data-jc-nav-clist]', dlg), q = $('[data-jc-nav-cq]', dlg), status = $('[data-jc-nav-cstatus]', dlg), form = $('form', dlg);
    if (!raw || !list || !form) return;
    var cd;
    try { cd = JSON.parse(raw.textContent); } catch (e) { return; }
    dlg._jcCountry = true;
    cd.list.forEach(function (c) { c.k = norm(c.n); });
    function row(c) {
      var on = c.i === cd.current;
      return '<li><button type="submit" name="country_code" value="' + esc(c.i) + '" class="jc-nav-cl__b"' + (on ? ' aria-current="true"' : '') + '>' +
        '<img class="jc-nav-cl__flag" src="' + esc(c.f) + '" width="24" height="18" alt="" loading="lazy" decoding="async">' +
        // <bdi>: a right-to-left symbol (AED د.إ) keeps its own order instead of scrambling the row
        '<span class="jc-nav-cl__n">' + esc(c.n) + '</span><span class="jc-nav-cl__c">' + esc(c.c) + ' <bdi>' + esc(c.s) + '</bdi></span>' +
        (on ? TICK : '<span aria-hidden="true"></span>') + '</button></li>';
    }
    function ul(items) { return '<ul class="jc-nav-cl__ul" role="list">' + items.map(row).join('') + '</ul>'; }
    function render(f) {
      f = norm(f).trim();
      var html;
      if (!f) {
        var want = String(cd.top || '').toUpperCase().split(/[^A-Z]+/).filter(Boolean);
        var top = cd.list.filter(function (c) { return c.i === cd.current; })
          .concat(want.map(function (i) { return cd.list.filter(function (c) { return c.i === i && c.i !== cd.current; })[0]; }).filter(Boolean))
          .concat(cd.list.filter(function (c) { return c.p && c.i !== cd.current && want.indexOf(c.i) < 0; }));
        html = (top.length ? '<p class="jc-nav-cl__h">' + esc(cd.popular) + '</p>' + ul(top) : '') + '<p class="jc-nav-cl__h">' + esc(cd.all) + '</p>' + ul(cd.list);
        if (status) status.textContent = '';
      } else {
        var alias = ALIAS[f];
        var hits = cd.list.filter(function (c) {
          return c.k.indexOf(f) > -1 || c.i.toLowerCase() === f || c.c.toLowerCase() === f || (alias && c.i === alias);
        }).sort(function (a, b) {
          var sa = (alias && a.i === alias) || a.k.indexOf(f) === 0 ? 0 : 1, sb = (alias && b.i === alias) || b.k.indexOf(f) === 0 ? 0 : 1;
          return sa - sb || a.k.localeCompare(b.k);
        });
        html = hits.length ? ul(hits) : '<p class="jc-nav-cl__none">' + esc(cd.none) + '</p>';
        if (status) status.textContent = String(hits.length);
      }
      list.innerHTML = html;
    }
    if (q) {
      q.addEventListener('input', function () { render(q.value); list.scrollTop = 0; });
      q.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); var b = $('.jc-nav-cl__b', list); if (b && q.value.trim()) b.click(); }
        if (e.key === 'Escape') { e.preventDefault(); closeDialog(dlg); }
      });
    }
    dlg.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var bs = $$('.jc-nav-cl__b', list);
      if (!bs.length) return;
      var i = bs.indexOf(document.activeElement);
      e.preventDefault();
      if (e.key === 'ArrowDown') (bs[i + 1] || bs[0]).focus();
      else if (i <= 0) { if (q) q.focus(); } else bs[i - 1].focus();
    });
    form.addEventListener('submit', function () {
      var rt = form.querySelector('input[name="return_to"]');
      if (rt) rt.value = window.location.pathname + window.location.search + window.location.hash;
      track('nav_country');
    });
    var built = false;
    openers[dlg.id] = function () {
      if (q) q.value = '';
      render('');
      built = true;
      list.scrollTop = 0;
      if (wide.matches && q) { try { q.focus({ preventScroll: true }); } catch (x) { q.focus(); } }
    };
    return built;
  }

  /* ---------- Footer: the shelf, save for later, the peek ---------- */
  function initPeek(p) {
    if (!p || p._jc) return;
    p._jc = true;
    var bag = $('[data-jc-nav-peek-bag]', p);
    if (bag) bag.addEventListener('pointerdown', function () { squish(bag); });
    if (p.closest('dialog')) return; // the menu's peek wakes when the menu scrolls to it (initMenu)
    if (!('IntersectionObserver' in window)) { p.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.disconnect();
        p.classList.add('is-in');
        wobble(bag, 750);
      });
    }, { threshold: 0.45 });
    io.observe(p);
  }
  function initFooter(f) {
    if (f._jc) return;
    f._jc = true;
    var shelf = $('[data-jc-nf-shelf]', f);
    if (shelf) {
      var figs = $$('[data-jc-nav-hop]', shelf);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            io.disconnect();
            wave(figs.filter(function (x) { return inView(x); }), 60, 14);
          });
        }, { threshold: 0.6 });
        io.observe(shelf);
      }
      $$('.jc-nf__bag', shelf).forEach(function (a) {
        var fig = $('[data-jc-nav-hop]', a);
        a.addEventListener('mouseenter', function () { if (hoverable.matches) hop(fig, 12); });
        a.addEventListener('focus', function () { hop(fig, 10); });
      });
    }
    var form = $('[data-jc-nf-save]', f);
    if (form) {
      var tags = $('[data-jc-save-tags]', form), name = $('[data-jc-colour-name]', form), img = $('.jc-nf-save__img', form), crop = $('.jc-nf-save__crop', form);
      var dots = $$('[data-jc-nf-dot]', form);
      var show = function (slug, setTags) {
        var c = colour(slug);
        if (!c) return;
        dots.forEach(function (d) { d.setAttribute('aria-pressed', d.getAttribute('data-jc-nf-dot') === slug ? 'true' : 'false'); });
        if (name && name.textContent !== c.n) name.textContent = c.n;
        if (setTags && tags) tags.value = 'newsletter,saved-' + slug;
        f.style.setProperty('--nf-c', c.h);
        swapImg(img, slug);
      };
      f._jcSave = show;
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          savePicked = true;
          show(d.getAttribute('data-jc-nf-dot'), true);
          hop(crop, 6);
        });
      });
      // jc.js renames [data-jc-colour-name] and retags when the buy box changes colour: follow it
      if (name) new MutationObserver(function () { var c = byName(name.textContent); if (c) show(c.s, false); }).observe(name, { childList: true, characterData: true, subtree: true });
    }
    initPeek($('[data-jc-nav-peek]', f));
  }

  /* ---------- Clicks (one listener for the whole site) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var op = t.closest('[data-jc-nav-open]');
    if (op) {
      var d = document.getElementById(op.getAttribute('data-jc-nav-open'));
      if (d && openDialog(d, op, e.detail > 0)) e.preventDefault();
      return;
    }
    var sw = t.closest('[data-jc-nav-swap]');
    if (sw) {
      e.preventDefault();
      var from = sw.closest('dialog');
      if (from) closeDialog(from, true, true);
      openDialog(document.getElementById(sw.getAttribute('data-jc-nav-swap')), $('.jc-nav__burger') || sw, e.detail > 0);
      return;
    }
    var cl = t.closest('[data-jc-nav-close]');
    if (cl) { e.preventDefault(); closeDialog(cl.closest('dialog')); return; }
    var cart = t.closest('[data-jc-nav-cart]');
    if (cart) { e.preventDefault(); openCart(cart); return; }
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
    var col = t.closest('[data-jc-nav-colour]') || t.closest('[data-jc-nav-cta]');
    if (col) {
      var slug = col.getAttribute('data-jc-nav-colour') || col.getAttribute('data-slug') || cur;
      if (slug && pickOnPage(slug, col)) e.preventDefault();
    }
  });
  window.addEventListener('pagehide', function () { $$('dialog[data-jc-nav-dialog][open]').forEach(function (d) { closeDialog(d, true, true); }); });

  /* ---------- Warm the bags before they're needed (on intent, and once the page is idle) ---------- */
  function warm(box) { if (box) $$('img[loading="lazy"]', box).forEach(function (i) { i.loading = 'eager'; }); }
  function initWarm() {
    if (api._warm) return;
    api._warm = true;
    function menuBox() { return wide.matches ? $('[data-jc-nav-mega]') : $('#JcNavMenu'); }
    ['pointerenter', 'pointerdown', 'focusin'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (t.closest('[data-jc-nav-open="JcNavMenu"], [data-jc-nav-mega-item]')) warm(menuBox());
        else if (t.closest('[data-jc-nav-open="JcNavSearch"]')) warm($('#JcNavMenu'));
      }, true);
    });
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 2500); };
    // Desktop: the colour panel. Phones: only the three bags she'll see first in the menu (hers and her neighbours)
    window.addEventListener('load', function () {
      idle(function () {
        if (wide.matches) { warm(menuBox()); return; }
        var lis = $$('#JcNavMenu [data-jc-nav-rail] .jc-nav-fam__li'), n = lis.length;
        var at = lis.findIndex(function (l) { return l.getAttribute('data-jc-nav-tile') === cur; });
        if (at < 0) return;
        [at - 1, at, at + 1].forEach(function (i) { warm(lis[(i + n) % n]); });
      }, { timeout: 5000 });
    });
  }

  /* ---------- Init ---------- */
  function init(scope) {
    scope = scope || document;
    $$('[data-jc-nav]', scope).forEach(function (root) { initSticky(root); initMega(root); initDrops(root); });
    $$('dialog[data-jc-nav-dialog]', scope).forEach(function (dlg) {
      wireDialog(dlg);
      if (dlg.id === 'JcNavMenu') initMenu(dlg);
      else if (dlg.id === 'JcNavSearch') initSearch(dlg);
      else if (dlg.id === 'JcNavCountry') initCountry(dlg);
    });
    $$('[data-jc-nf]', scope).forEach(initFooter);
    $$('[data-jc-nav-peek]', scope).forEach(initPeek);
    initCartIcon();
    initWarm();
  }
  /* The phone menu's link notes: set savings ([save2] / [save3]) are printed by Liquid in the store currency; in any
     other currency they're converted here (Shopify.currency.rate) and formatted like her price (data-money-sample).
     Without a rate the note stays hidden (CSS hides a note whose amount is empty). */
  function fillNavMoney() {
    var root = $('[data-jc-nav]');
    var spans = [].slice.call(document.querySelectorAll('[data-jc-nav-usd]'));
    if (!root || !spans.length || root.getAttribute('data-currency') === root.getAttribute('data-shop-currency')) return;
    var r = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
    var sample = root.getAttribute('data-money-sample') || '';
    var m = sample.match(/^(.*?)(\d[\d.,\s ]*\d|\d)(.*)$/);
    if (!(r > 0) || !m) return;
    var grp = /\.\d{3}/.test(m[2]) && !/,\d{3}/.test(m[2]) ? '.' : (/[\s ]\d{3}/.test(m[2]) ? ' ' : ',');
    if (window.jcMoneyGrp) grp = window.jcMoneyGrp;   // her currency's own thousands separator (layout/theme.liquid)
    spans.forEach(function (el) {
      var cents = parseFloat(el.getAttribute('data-jc-nav-usd')) * r;
      if (isFinite(cents) && cents > 0) el.textContent = m[1] + window.jcNum(cents, grp) + m[3];
    });
  }

  function start() {
    init(document);
    fillNavMoney();
    // Her colour: the fold's (watched), else the last one she chose, else the product's own
    var d = data();
    var saved = store('jc-sel');
    var first = (saved && saved.colour && colour(saved.colour) && !hasFold()) ? saved.colour : (d && d.current);
    if (first && colour(first)) setCurrent(first);
    else { var any = allColours()[0]; if (any) cur = any.s; }
    watchPageColour();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (e) {
    D = null;
    init(e.target);
    if (cur) setCurrent(cur);
    // The editor re-rendered the header: give the new bag icon back to Dawn's cart drawer
    var drawer = document.querySelector('cart-drawer'), b = document.getElementById('cart-icon-bubble');
    if (drawer && b && e.target.contains(b) && typeof drawer.setHeaderCartIconAccessibility === 'function') drawer.setHeaderCartIconAccessibility();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var sec = e.target.closest && e.target.closest('.jc-nav-sec');
    if (sec && !wide.matches && e.target.closest('.jc-nav-menu') == null) api.open('JcNavMenu');
  });
})();
